'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearBefore.js
// module id = 759
// module chunks = 0